module.exports = __webpack_public_path__ + "static/media/tutorial_banner.ecd5611e.jpg";